// TotalModa Swarovski Experience for Horizon Theme
(function() {
  function initSwarovskiAnimations() {
    if (!('IntersectionObserver' in window)) return;

    // 1. Target cards & media
    const cardSelectors = [
      '.collection-card',
      'product-card',
      '.product-card',
      '.resource-list__item',
      '#star-product-section .swarovski-video-col',
      '#new-product-section .swarovski-image-col',
      '#star-product-section .swarovski-content-card',
      '#new-product-section .swarovski-content-card'
    ];

    // 2. Target text blocks & headings in sections
    const textSelectors = [
      '.section-content-wrapper .text-block',
      '.section-wrapper h2',
      '.section-wrapper h3',
      '.section-wrapper .h2',
      '.section-wrapper .h4'
    ];

    const cardElements = document.querySelectorAll(cardSelectors.join(', '));
    const textElements = document.querySelectorAll(textSelectors.join(', '));

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target;
          if (target.dataset.animType === 'card') {
            target.classList.add('swarovski-animated-card');
          } else {
            target.classList.add('swarovski-animated-text');
          }
          obs.unobserve(target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.08
    });

    const windowHeight = window.innerHeight || 800;

    // Register cards
    cardElements.forEach(el => {
      if (el.closest('header') || el.closest('.header-section') || el.closest('.announcement-bar') || el.closest('.hero-wrapper')) {
        return;
      }
      el.dataset.animType = 'card';
      const rect = el.getBoundingClientRect();
      if (rect.top < windowHeight * 0.75 && rect.bottom > 0) {
        el.classList.add('swarovski-animated-card');
      } else {
        observer.observe(el);
      }
    });

    // Register texts
    textElements.forEach(el => {
      if (el.closest('header') || el.closest('.header-section') || el.closest('.announcement-bar') || el.closest('.hero-wrapper')) {
        return;
      }
      el.dataset.animType = 'text';
      const rect = el.getBoundingClientRect();
      if (rect.top < windowHeight * 0.75 && rect.bottom > 0) {
        el.classList.add('swarovski-animated-text');
      } else {
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwarovskiAnimations);
  } else {
    initSwarovskiAnimations();
  }
})();
